module.exports = __webpack_public_path__ + "assets/img/terminalPic13.e82a547b.jpg";